// @ts-ignore
import {ICustomerState} from "./states/ICustomerState.interface";

const customer = {
    prefix: 'customer.',
    namespaced: true,
    state: <ICustomerState>{
        token: null,
        hash: null,
        expire_time: null,
        first_name: null,
        last_name: null,
        email: null,
        mobno: null,
        company_name: null,
        company_number: null,
        company_vat: null,
        address: null,
        sessionEnd: false,
        // isLogged: false,
        printing: false,
        error_existing_customer: false,
    },
    mutations: {
        INITIALIZE(state: ICustomerState) {
            state['defaultState'] = {...state};

            for (const prop of Object.getOwnPropertyNames(state)) {
                let value = localStorage.getItem(customer.prefix + prop);

                if (value) {
                    state[prop] = JSON.parse(value);
                }
            }
        },
        SET_STATE_PROP_VALUE(state, payload: {prop: string, value: any}[]): void {

            for (const obj of payload) {
                if (! state.hasOwnProperty(obj.prop)) {
                    console.error('Trying to set state prop that doesn\'t exist');
                    return;
                }
            }

            for (const obj of payload) {
                const prop = obj.prop;
                const value = obj.value;

                state[prop] = value;

                localStorage.removeItem(customer.prefix + prop);

                if (value !== undefined) {
                    localStorage.setItem(customer.prefix + prop, value ? JSON.stringify(value) : value);
                }
            }
        },
        CLEAR_STATE(state: ICustomerState): void {
            for (const prop of Object.getOwnPropertyNames(state)) {
                localStorage.removeItem(customer.prefix + prop);

                if (state.defaultState) {
                    state[prop] = state.defaultState[prop];
                }
            }
            state['defaultState'] = {...state};
        }
    },
    actions: {
    },
    getters: {
        isLoggedIn: (state) => {
            return !!state.token;
        }
    }
}

export default customer;